import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  finalSaveLoading: false,
  requestedProducts: {},
  proofFiles: {},
  detailedQuote: {},

  UIToken: "",
  error: null,
  totalCount: 0,
  totalPages: 1,
  rejectionMessage: "",
  approvedByPerson: "",
  estimateRejectionMessage: "",
  updatedRequestedData: undefined,
  updatedShippinPrice: undefined,
  paymentAmount: 0,
  couponListLoading: false,
  coupon: [],
  couponAdded: {},
  requestedProduct: null,
  couponCode: "",
  signedUploadComplete: {},
  stopPlaceOrder: false,
  stopSaveAndContinue: false
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const publicSlice = createSlice({
  name: "public",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.action) {
        state.actionsLoading = false;
      } else {
        state.finalSaveLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else if (action.payload.callType === callTypes.action) {
        state.actionsLoading = true;
      } else {
        state.finalSaveLoading = true;
      }
    },
    callSuccess: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.action) {
        state.actionsLoading = false;
      } else {
        state.finalSaveLoading = false;
      }
    },
    requestItemFetched: (state, action) => {
      state.requestedProducts = action.payload;
      state.listLoading = false;
      state.error = null;
    },
    proofFetched: (state, action) => {
      state.proofFiles = action.payload[0];
      state.listLoading = false;
      state.error = null;
    },
    paymentUITokenFetched: (state, action) => {
      state.UIToken = action.payload.token;
      state.actionsLoading = false;
      state.error = null;
    },
    clearPaymentUIToken: (state, action) => {
      state.UIToken = "";
    },
    createRejectionMessage: (state, action) => {
      state.rejectionMessage = action.payload;
    },

    rejectionMessage: (state, action) => {
      state.estimateRejectionMessage = action.payload;
    },

    updatedRequestedData: (state, action) => {
      let { updatedRequestedData, updatedShippinPrice, paymentAmount } =
        action.payload;
      state.updatedRequestedData = updatedRequestedData;
      state.updatedShippinPrice = updatedShippinPrice;
      state.paymentAmount = paymentAmount;
    },

    approvedByPersonName: (state, action) => {
      state.approvedByPerson = action.payload;
    },
    updateRequest: (state, action) => {
      let { requestedProduct } = action.payload;
      delete requestedProduct.estimateSendByUserDetails;
      // delete requestedProduct.assignedSalesUserDetails;

      state.error = null;
      state.requestedProduct = {
        ...state.requestedProduct,
        ...requestedProduct,
      };
      state.listLoading = false;
      state.actionsLoading = false;
    },
    couponFetched: (state, action) => {
      const { totalPages, totalCount, coupon } = action.payload;
      state.couponListLoading = false;
      state.error = null;
      state.coupon = coupon;
      state.totalCount = totalCount;
      state.totalPages = totalPages;
    },
    couponDetails: (state, action) => {
      state.error = null;
      state.couponAdded = action.payload;
    },
    detailedQuote: (state, action) => {
      state.error = null;
      state.detailedQuote = action.payload.detailedQuote[0];
      state.listLoading = false;
    },
    couponCodeName: (state, action) => {
      const { code } = action.payload;
      state.error = null;
      state.couponCode = code;
    },
    signedUrlFetched: (state, action) => {
      state.signedUploadComplete = action.payload;
    },
    stopPlaceOrder: (state, action) => {
      state.stopPlaceOrder = action.payload;
    },
    stopSaveAndContinue: (state, action) => {
      state.stopSaveAndContinue = action.payload;
    },
  },
});
